import {createDetailResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const transactionSchema = z.object({
  response: z.object({
    transaction: z.object({
      customerID: z.string(),
      no: z.string(),
      date: z.string(),
      totalAmount: z.number(),
      storeNo: z.string(),
      posNo: z.string(),
      cardNo: z.string(),
      type: z.number(),
      barCode: z.string(),
      couponCodes: z.string(),
      detail: z.string(),
      id: z.string(),
      brand: z.string(),
      returnedTransactionID: z.string(),
      createdDate: z.string(),
    }),
  }),
  responseResult: z.object({
    result: z.boolean(),
    exceptionDetail: z.string(),
  }),
})

export const transactionDetailSchema = z.object({
  channel: z.any(),
  date: z.string(),
  discountAmount: z.number(),
  pointEarned: z.number(),
  pointReedemption: z.any(),
  orderId: z.string().nullable(),
  posNo: z.any().nullable(),
  storeNo: z.string().nullable(),
  terminalId: z.string().nullable(),
  totalAmount: z.number(),
  purchaseAmount: z.number(),
  paidAmount: z.number(),
  feeAmount: z.number(),
  transactionId: z.string(),
  type: z.any(),
  pointCampaigns: z
    .array(
      z.object({
        campaignID: z.string(),
        campaignName: z.string().nullable(),
        pointActivationDate: z.string(),
        type: z.any(),
        name: z.string().nullable(),
        skuID: z.string().nullable(),
        status: z.any(),
        pointsEarned: z.number(),
        // deferredBonus: z.number()
      })
    )
    .nullable(),
  productDetails: z
    .array(
      z.object({
        skuId: z.string().nullable().optional(),
        productName: z.string().optional().nullable(),
        quantity: z.number(),
        unitPrice: z.number(),
        discountedPrice: z.number(),
        // discountRate: z.number()
      })
    )
    .nullable(),
  paymentTypes: z
    .array(
      z.object({
        date: z.string(),
        paymentType: z.any(),
        amount: z.number(),
      })
    )
    .nullable(),
  discountCampaigns: z
    .array(
      z.object({
        campaignID: z.string(),
        campaignName: z.string().nullable(),
        skuid: z.string(),
        productName: z.any(),
        quantity: z.number(),
        unitPrice: z.number(),
        discountedPrice: z.number(),
        // discountedRate: z.number(),
        couponCodes: z.any(),
      })
    )
    .nullable(),
})

// export const transactionDetailSchemaResponse = createDetailResponseSchema(z.object({ transaction: transactionDetailSchema.nullable() }));
export const transactionDetailSchemaResponse = createDetailResponseSchema(
  transactionDetailSchema.nullable()
)

export type Transaction = z.infer<typeof transactionSchema>
export type TransactionDetail = z.infer<typeof transactionDetailSchema>
